import React from 'react';
import {cn} from "@gettactic/helpers";

export interface CardTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Optional title
   */
  title?: string;
  /**
   * Optional subheading
   */
  subheading?: string;
  /**
   * Optional bottom border
   */
  border?: boolean;
}

export const CardTitle: React.FC<CardTitleProps> = ({
  title,
  subheading,
  border = false,
  children
}) => {
  return (
    <div
      className={cn(
        'px-4 sm:p-6',
        border ? 'border-b border-card-border' : ''
      )}
    >
      <div className="space-between flex items-center">
        <div className="flex w-full flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="flex flex-col">
            {title && (
              <h3 className="text-lg font-bold leading-6 text-neutral-900">
                {title}
              </h3>
            )}
            {subheading && (
              <p className="mt-1 text-sm text-neutral-500">{subheading}</p>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};